// extracted by extract-css-chunks-webpack-plugin
module.exports = {"teal":"#27b4a5","red300":"#ef7874","blue100":"#0097ba","grey100":"#656565","grey200":"#8b8b8b","grey300":"#a2a3a5","grey400":"#e3e3e3","black":"#211614"};